module.exports = __webpack_public_path__ + "burger.svg?a05c8de8bc99c57368f7802c590b3fc6";